import React, { Component } from 'react';
import Link from '../../_core/components/Link';
import Resize from '../../_core/utils/Resize';
import Content from '../../_core/components/Content';
import Icon from '../../_core/components/Icon';


let placeholder = {

  modifier : 'default',
  text1 : 'Strength with elegance.',
  text2 : 'Lightness of touch.',
  text3 : 'Attention to detail.',
  finalText : 'A warehouse for creative working'
}

class Com extends Component {


  constructor(props){

      super(props);
  }

  componentDidMount = () => {

      const _this = this;

  }

  // Height relative to original artboard height (679) scaled to window
  height = (num) => {
    return Math.round((num / 679) * window.innerHeight);
  }

  y = (num) => {
    return this.height(num);
  }

  // Width relative to original artboard width (1024) scaled to window
  width = (num) => {
    return Math.round((num / 1024) * window.innerWidth);
  }

  x = (num) => {
    return this.width(num);
  }

  render() {    

    let props = {...placeholder,...this.props}
    let modifier = props.modifier || 'default';

    return (
        
        <Resize onResize={() => this.setState({w:window.InnerWidth,h:window.innerHeight})}>
        <div className="Intro" data-layout="fluid" ref={(el) => this.props.setRef && this.props.setRef('wrapper',el)}>
          <div className="Intro-logo"  data-layout-center>
            <div ref={(el) => this.props.setRef && this.props.setRef('logo',el)}>
              <div className="Intro-logo-svg" />
            </div>
          </div>
         
          <div className="Intro-top" data-layout-tm ref={(el) => this.props.setRef && this.props.setRef('toptext',el)}>
              
             <Content>
              <h2>67 Whitfield Street</h2>
             </Content>
          </div>

          <div className="Intro-bottom" data-layout-bm ref={(el) => this.props.setRef && this.props.setRef('bottomtext',el)}>
              
             <Content>
              <h2>Class E restaurant / café opportunity<br />in a landmark building</h2>
             </Content>
          </div>
         
          <div className="Intro-background" data-layout="fluid">

            <svg version="1.1" id="Shapes" xmlns="http://www.w3.org/2000/svg" xmlnsXLink="http://www.w3.org/1999/xlink" x="0px" y="0px"
               viewBox={`0 0 ${window.innerWidth} ${window.innerHeight}`} style={{"enable-background":`new 0 0 ${window.innerWidth} ${window.innerHeight}`}}>
                <style type="text/css">
                {
                  `.st0{fill:#FF785A;}
                  .st2{fill:#FFFF02;}
                  .st1{fill:#375A63;}
                  .st3{fill:none;stroke:#BE9A5D;stroke-width:8;}`
                }
                </style>
                <rect ref={(el) => this.props.setRef && this.props.setRef('pink_2',el)} id="pink_x5F_2" x="0" y="57" className="st0" width={this.width(330)} height={this.height(620)}/>
                <rect ref={(el) => this.props.setRef && this.props.setRef('yellow_1',el)} id="yellow_x5F_2" x={this.x(601)} y={this.y(464)} className="st1" width={this.width(423)} height={this.height(171)}/>
                <rect ref={(el) => this.props.setRef && this.props.setRef('pink_1',el)} id="pink_x5F_1" x="0" y={this.y(432)} className="st0" width={this.width(676)} height={this.height(247)}/>
                <rect ref={(el) => this.props.setRef && this.props.setRef('yellow_2',el)} id="yellow_x5F_1" x={this.x(216)}  className="st1" width={this.width(808)} height={this.height(490)}/>
                <rect ref={(el) => this.props.setRef && this.props.setRef('blue_2',el)} id="blue_x5F_2" x="662" x={this.x(662)} y="0" className="st2" width={this.width(361)} height={this.height(123)} />
                <rect ref={(el) => this.props.setRef && this.props.setRef('blue_1',el)} id="blue_x5F_1" x="867" x={this.x(867)} y="0" className="st2"  width={this.width(157)} height={this.height(431)}/>
                <polyline ref={(el) => this.props.setRef && this.props.setRef('br_line',el)} id="br_x5F_line" class="st3" points={`${this.x(729)},${this.y(700)} ${this.x(729)},${this.y(557)} ${this.x(1024)},${this.y(557)}`}/>
                <polyline ref={(el) => this.props.setRef && this.props.setRef('tl_line',el)} id="tl_x5F_line" class="st3" points={`0,${this.y(387)} ${this.x(175)},${this.y(387)} ${this.x(175)},${this.y(172)} ${this.x(320)},${this.y(172)} ${this.x(320)},0`} />
            </svg>

          </div>
        </div>
        </Resize>
    );
  }
}



export default Com;



// WEBPACK FOOTER //
// ./src/js/components/_layouts/Intro.js